exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n/*************************/\n/*     18. Copyright     */\n/*************************/\n.copyright {\n\ttext-align: center;\n}\n", "", {"version":3,"sources":["/home/cubo/pospimus/client/components/footer/footer.css"],"names":[],"mappings":";AACA,2BAA2B;AAC3B,2BAA2B;AAC3B,2BAA2B;AAC3B;CACC,mBAAmB;CACnB","file":"footer.css","sourcesContent":["\n/*************************/\n/*     18. Copyright     */\n/*************************/\n.copyright {\n\ttext-align: center;\n}\n"],"sourceRoot":""}]);

// exports
